import { formatVisitDateOrHour } from '../../../helpers/utils'

export function formatLastActivity(lastVisit) {
  if (lastVisit == null || lastVisit === '' || lastVisit === '-') return '—'
  const formatted = formatVisitDateOrHour(lastVisit)
  return formatted && formatted.includes('Invalid') ? '—' : formatted
}
